import {fun_Download, fun_PostAction} from "@/api/index";
export default {
  data() {
    return {
      // 默认关闭
      dialogVisible: false,
      // 招标编号
      projectId: null,
      // 文件类型
      fileType: null,
      // 用户编号
      tbUserId: null,
      // 资格预审形式
      prequalificationType: null,
      // 左侧目录当前选中的节点
      currentKey: null,
      // 左侧树形菜单数据
      treeData: [],
      // 中间投标单位
      bidList: [],
      // 当前选择的投标单位
      bidIndex: 0,
      // pdf路径
      pdfUrl: null,
    }
  },
  // 接收父组件传递的数据
  props: {

  },
  // 模板编译完成
  mounted() {

  },
  // 自定义方法
  methods: {

    /**
     * 获取列表一览数据
     * @author shuhua
     */
    fun_GetList() {
      // 打开loading
      this.loading = true;
      // 发起请求
      fun_PostAction("/evaluationPublicity/getEvaPublicityAuditFileList", {
        tenderReference: this.projectId,
        prequalificationType: this.prequalificationType,
      }).then(res => {
        // 解构res.data
        const { result, data, msg } = res.data;
        // 操作成功
        if (result) {
          // 赋值data
          this.treeData = data;
          console.log(this.treeData)
          // 默认选中第一个
          this.fun_HandleNodeClick(data[0]);
        } else {
          // 错误消息提示
          this.$message.error(msg);
        }
        // 关闭loading
        this.loading = false;
      })
    },


    /**
     * iframe加载完成后执行的方法
     */
    iframeLoaded() {
      // 通过id获取iframe元素
      let iframe = document.getElementById("iframePdf");
      // 获取iframe内容文档对象
      let iframeDoc = iframe.contentDocument || iframe.contentWindow.document;
      // 获取iframe中的header元素
      let header = iframeDoc.getElementsByTagName("header")[0];
      // 存在header元素
      if (header) {
        // 修改背景颜色
        header.style.backgroundColor = "#12989b";
      }
    },
    /**
     * 点击左侧树形菜单
     */
    fun_HandleNodeClick(data) {
      // 路径不为空
      if (data.path != null && data.path != "") {
        // 赋值
        this.currentKey = data.id;
        // 回调设置样式
        // this.$nextTick(() => {
        //   // 设置选中样式
        //   this.$refs.fileTree.setCurrentKey(data.id);
        // });
        this.fun_OpenPdf(data.path);
      }
    },

    /**
     * 调用PDF
     */
    fun_OpenPdf(e){
      // 获取id
      fun_Download("/downloadLocal?filePath=" + e).then(res => {
        // 存储this
        const data = new Blob([res.data], { type: "application/pdf" });
        // 预览PDF
        this.pdfUrl =
            URL.createObjectURL(data);
      });
    },

  }
}